import React, { useState } from "react";

import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { checkIfTargetValueIsANumberAndReturnCurrentValueIfNot } from "Utils/formUtils";

export interface Props {
  id: string;
  name: string;
  label: string;
  hint?: string;
  error: string;
  onChange?: (arg: string) => void;
  postNumber?: string;
  labelPopover?: React.ReactElement;
}

export const PostNumberInput = ({
  postNumber,
  onChange,
  ...rest
}: Props): React.ReactElement => {
  const [input, setInput] = useState("");

  return (
    <Input
      {...rest}
      onChange={(e) => {
        e.target.value = checkIfTargetValueIsANumberAndReturnCurrentValueIfNot(
          input,
          e.target.value,
          postNumber,
        );
        setInput(e.target.value);
        onChange && onChange(e.target.value);
      }}
      inputMode={InputMode.NUMERIC}
      inputProps={{ maxLength: 4 }}
      labelPopover={rest.labelPopover}
    />
  );
};
